import { render, staticRenderFns } from "./PhoneCode.vue?vue&type=template&id=2b1c70b6&scoped=true"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"
import style0 from "./PhoneCode.vue?vue&type=style&index=0&id=2b1c70b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c70b6",
  null
  
)

export default component.exports